import React from 'react'
import PropTypes from 'prop-types'

import { Testable } from '@cred/react-testable'
import { withStyles } from '@cred/react-theme'
import { isMobileWidth } from '@cred/shared/utils'

import CtaButton from 'components/cta-button'

import defaultStyles from './themes/default/styles.module.scss'
import insider from './themes/insider/styles.module.scss'

const CompareRates = ({ onGetStarted, analyticsContexts, styles = defaultStyles }) => {
  const isMobile = isMobileWidth()
  return (
    <Testable className={styles.container} testId="personalized-rates">
      <div className={styles.leftColumn}>
        <p className={`${styles.headingText} secondary700 medium semiBold`}>
          Now let’s personalize these rates just for you
        </p>
        <p className="mt-8 neutral500">
          Go beyond generic rates to see prequalified options from these lenders, customized for
          you. It takes just two minutes and won’t impact your credit score.
        </p>
      </div>
      <Testable testId="submit" className={styles.buttonContainer}>
        <CtaButton
          className={styles.button}
          onClick={onGetStarted}
          analyticsContexts={analyticsContexts}
          fullWidth={isMobile}
        >
          Get started
        </CtaButton>
      </Testable>
    </Testable>
  )
}
CompareRates.propTypes = {
  onGetStarted: PropTypes.func.isRequired,
  analyticsContexts: PropTypes.array.isRequired,
  styles: PropTypes.object,
}

export default withStyles(defaultStyles, { insider })(CompareRates)
